<template>
<div id="body" >
    <div id="loader" ref="Loader" class="loading">
        <div class="bounceball"></div>
        <div class="text"></div>
    </div>
    <div id="homecontent" ref="Content" v-if="!noAccess">
    <div class="container listbody" >
        <div class="card shadow" v-for="(user, index) in users" :key="index">
            <router-link @click.native="scrollTop" :to="{name: 'Details', params: {user_id: user.id}}" class="card-link" >
            <div class="card-header d-flex flex-row justify-content-around">
                <div class="avatar" v-bind:style="{ 'background-image': 'url(\'' + user.Icon + '\')' }"></div>
                <div class="image-container"><img :src="user.Logo" class="companyLogo"/></div>
            </div>
            <div class="card-body">
                <p class="name">{{ user.FirstName}} {{ user.LastName}}</p>
                <div class="infoitem">
                    <span><img class="icon" src="../assets/icons8-organization-50.png"/></span>
                    <span>{{user.CompanyName}}</span>
                </div>
                <div class="infoitem">
                    <span><img class="icon" src="../assets/icons8-prize-50.png"/></span>
                    <span>{{user.Role}}</span>
                </div>
                <div class="infoitem">
                    <span><img class="icon" src="../assets/icons8-envelope-50.png"/></span>
                    <span>{{user.Email}}</span>
                </div>
            </div>
            <div class="card-footer">
                {{user.BriefDescription}}
            </div>
            </router-link>
        </div>
    </div>
    </div>
    <div v-if="noAccess">
    <div id="message" v-if="!hideMessage">
        <a @click.prevent="hideMessageBlock" class="close"/>
        <p>{{message}}</p>
    </div>
    <div class="container emptybody">
        <div v-for="n in numbers" :key="n">
            <img src="../assets/thumb-wireframe.png"/>
        </div>
    </div>
    </div>
</div>
</template>
<script>
import Navbar from '@/components/layout/Navbar'
import firebase from '@/firebase/init'
import functions from 'firebase/functions'
export default {
    name: 'Home',
    data(){
        return{
            users:[],
            noAccess: false,
            hideMessage: false,
            numbers: [1,2,3,4,5,6],
            message: "Your submission is currently in review. Once approved, you'll be able to view other companies here."
        }
    },
    methods:{
        scrollTop(){
            window.scrollTo(0, 0)
        },
         hideMessageBlock(){
            this.hideMessage = true
        }
    },
    created(){
        firebase.auth().onAuthStateChanged((user)=>{
            if(user){
                var db = firebase.firestore()
                let ref = db.collection('users').where('UID', '==', user.uid)
                ref.get().then(snapshot=>{
                    if(snapshot.docs.length === 0){
                        this.noAccess = true
                        this.message = "Your account is not found"
                    }
                    snapshot.forEach(doc=>{
                        var data = doc.data()
                        if(data.OnBoardingCompleted === true){
                            if(data.Approved === true){
                                this.noAccess = false
                                var storage = firebase.storage()
                                var storageRef = storage.ref()
                                db.collection('users').orderBy("CreateDate", "asc").get()
                                .then(snapshot =>{
                                    snapshot.forEach(doc=>{
                                        let user = doc.data()
                                        if(user.OnBoardingCompleted === true && user.Approved === true){
                                        let logoRef = storageRef.child(user.Logo)
                                        user.Logo = require('../assets/Spinner-1s-200px.gif')
                                        if(logoRef.location.path !== ""){
                                            logoRef.getDownloadURL().then(function(url) {
                                                user.Logo = url
                                            }).catch(function(error) {user.Logo = ''})
                                        }
                                        let avatarRef = storageRef.child(user.Icon)
                                        user.Icon = require("../assets/Spinner-1s-200px.gif")
                                        if(avatarRef.location.path !== ""){
                                            avatarRef.getDownloadURL().then(function(url) {
                                                user.Icon = url
                                            }).catch(function(error) {user.Icon = ''})
                                        }
                                        user.id = doc.id
                                        this.users.push(user)
                                        }
                                    })
                                })
                            }
                            else{
                                //this.$router.push({name: 'NoAccess'})
                                this.noAccess = true
                            }
                        }
                        else{
                            this.$router.push({name: 'Step1', params: {uid: user.uid, previousname: user.displayName, previousemail: user.email, previousrole: null, previousicon: null, previouscompanyName: null,
                            previousbriefdescription: null, previouslogo: null, previousdescription: null}} )
                        }
                    })
                })
            }
            else{
                this.$router.push({name: 'Login'})
            }
        })
    },
    beforeCreate: function() {
            document.body.className = 'list'
            this.$parent.showNavbar = true
            this.$parent.showBackButton = false
    },
    mounted(){
        var thisRef = this
        setTimeout(function(){
            if(thisRef.$refs.Loader)
                thisRef.$refs.Loader.style.display = "none"
            if(thisRef.$refs.Content)
                thisRef.$refs.Content.style.display = "block"
        }, 3000)
    }
}
</script>
<style scoped>
.image-container{
    width: 10em;
    height: 5em;
}
.icon{
    height: 18px;
    margin-right: 1em;
}
.infoitem{
    margin-top: 0.5em;
}
.listbody{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 1em;
    grid-gap: 2em;
}
#homecontent{
    display: none;
}
.avatar{
    transform: translateY(35%);
    width: 5em;
    height: 5em;
    -webkit-border-radius: 60px;
    -webkit-background-clip: padding-box;
    -moz-border-radius: 60px;
    -moz-background-clip: padding;
    border-radius: 60px;
    background-clip: padding-box;
    margin: 7px 0 0 5px;
    float: left;
    background-size: cover;
    background-position: center center;
}
.companyLogo{
    max-width: 100%;
    max-height: 100%;
}
.name{
    font-size: 1.3em;
    font-weight: bold;
    color: black;
    margin-bottom: 0;
}
.card-body{
    padding-left: 1em;
}
.card-footer{
    color: #9665c1;
    font-size: 0.8em;
    font-weight: bold;
    text-align: left;
    padding-left: 1em;
    background-color: white;
    border-radius: 0px 0px 6px 6px !important;
}
.card-body span{
    font-size: 0.8em;
    font-weight: 500;
    color: #909090;
}
.card-body div, .card-body p{
    text-align: left;
}
.card-header{
    padding-top: 2em;
    background-color: white;
    border-radius: 6px 6px 0px 0px !important;
}
.card{
    border-radius: 6px 6px 6px 6px !important;
    border: none;
    margin-bottom: 1em;
}
.card-link{
    cursor: pointer !important;
}
@media (max-width: 992px) {
    .listbody{
        grid-template-columns: 1fr 1fr;
    }
}
@media (max-width: 770px) {
    .listbody{
        grid-template-columns: 1fr;
    }
}

a:link{
    color: transparent;
text-decoration: none;
cursor: auto;
}
a:visited	{color: transparent;
text-decoration: none;
cursor: auto;	}
a:link:active	{color: transparent;}
a:visited:active{	color: transparent;}

/* Loader */

@import  url(https://fonts.googleapis.com/css?family=Montserrat);

#loader{
    height: 100%;
    position: relative;
    text-align: center;
    
}

#body {
  position: relative; 
  width: 100%;
  height: 100%;
  font-family: Montserrat;
}

.wrap {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.text {
    position: absolute;
    top: 45%;
    transform: translateY(-40%);
    color: #fbae17;
    display: inline-block;
    margin-left: 10px;
    margin-top: 20px;
}

.bounceball {
    position: absolute;
    top: 45%;
    transform: translateY(-40%);
    position: relative;
    display: inline-block;
    height: 37px;
    width: 15px;
}
.bounceball::before{
    position: absolute;
    content: '';
    display: block;
    top: 0;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background-color: #5D38DB;
    transform-origin: 50%;
    animation: bounce 500ms alternate infinite ease;
}
@keyframes bounce {
  0% {
    top: 40px;
    height: 5px;
    border-radius: 60px 60px 20px 20px;
    transform: scaleX(2);
  }
  35% {
    height: 20px;
    border-radius: 50%;
    transform: scaleX(1);
  }
  100% {
    top: 0;
  }
}
.emptybody{
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-top: 1em;
    grid-gap: 2em;
    text-align: center;
}
#message{
    background-color: white;
    position: absolute;
    z-index: 1;
    width: 25em;
    padding: 1.5em 1.5em 0.8em 1.5em;
    top: 35%;
    left: 42%;
}
.close {
  position: absolute;
  right: 5px;
  top: 10px;
  width: 32px;
  height: 32px;
  opacity: 0.3;
}
.close:hover {
  opacity: 1;
}
.close:before, .close:after {
  position: absolute;
  left: 15px;
  content: ' ';
  height: 15px;
  width: 2px;
  background-color: #333;
}
.close:before {
  transform: rotate(45deg);
}
.close:after {
  transform: rotate(-45deg);
}
@media (max-width: 1800px) {
    #message{
        left: 38%;
    }
}
@media (max-width: 1500px) {
    #message{
        left: 35%;
    }
}
@media (max-width: 1300px) {
    #message{
        left: 32%;
    }
}
@media (max-width: 992px) {
    .emptybody{
        grid-template-columns: 1fr 1fr;
    }
    #message{
        left: 30%;
    }
}
@media (max-width: 770px) {
    .emptybody{
        grid-template-columns: 1fr;
    }
    #message{
        width: 15em;
    }
}
@media (max-width: 550px) {
    .emptybody{
        grid-template-columns: 1fr;
    }
    #message{
        left: 20%;
    }}
</style>



// WEBPACK FOOTER //
// src/components/Home.vue